export default "__VITE_ASSET__c67edd68__"